// extracted by css-extract-rspack-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1_ZzH","cls2":"PostEngagementFollowPrompt-cls2_Xg8 PostEngagementFollowPrompt-cls1_ZzH"};